export class ApiPath {
    static readonly register = '/api/user/register'
    static readonly login = '/api/user/login'
    static readonly forgotPassword = '/api/user/forgot-password'
    static readonly changePassword = '/api/user/change-password'
    static readonly me = '/api/user/me'
    static readonly passkeyRegisterBegin = '/api/user/passkey/register/begin'
    static readonly passkeyRegisterFinish = '/api/user/passkey/register/finish'
    static readonly passkeyLoginBegin = '/api/user/passkey/login/begin'
    static readonly passkeyLoginFinish = '/api/user/passkey/login/finish'
    static readonly passkey = '/api/user/passkey'
    static readonly qrLoginCreate = '/api/user/qr-login/create'
    static readonly qrLoginPoll = '/api/user/qr-login/poll'
    static readonly qrLoginStatus = '/api/user/qr-login/status'
    static readonly qrLoginConfirm = '/api/user/qr-login/confirm'
    static readonly channel = '/api/channel'
    static readonly clipboard = '/api/clipboard'
    static readonly clipboardByChannel = '/api/clipboard/by-channel'
    static readonly checkNew = '/api/clipboard/check-new'
    static readonly clipboardDetail = '/api/clipboard/detail'
    static readonly fileUpload = '/api/clipboard/files'
    static readonly meta = '/api/clipboard/meta'
    static readonly clipboardDelete = '/api/clipboard/del/0'
}
